export default [
  'saveActivity',
  'getData',
  'setData',
  'isEditable',
  'activityTitle',
  'showIframePopup',
  'showVideoPopup',
];
